export const featureFlagKeys = {
  active: (): readonly string[] => [...featureFlagKeys.all, 'active'] as const,
  all: ['feature-flags'] as const,
};
